export const createJudgingProgrammeQuestionsRequests = (client) => ({
    findJudgingProgrammeQuestion: async (params) => {
        const { data } = await client.api.get(`judging_programme_questions/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map